module.exports = __webpack_public_path__ + "img/1533574623.cd98bb7c.jpg";